import { forwardRef } from 'react';
import { JumpLinkItem } from './JumpLinkItem';
import { Heading } from './hooks';

// base sizes (before scaling)
const MAX_NAV_HEIGHT = 400;

interface JumpLinksListProps {
  headings: Heading[];
  activeId: string;
  minLevel: number;
  scaledIndentMultiplier: number;
  scaledTextPadding: number;
  scaledFontSize: number;
  trackStyle: React.CSSProperties;
  onScrollTo: (id: string) => void;
}

export const JumpLinksList = forwardRef<HTMLDivElement, JumpLinksListProps>(
  (
    { headings, activeId, minLevel, scaledIndentMultiplier, scaledTextPadding, scaledFontSize, trackStyle, onScrollTo },
    ref
  ) => (
    <nav id="jump-links-list" ref={ref} className="overflow-y-auto" style={{ maxHeight: `${MAX_NAV_HEIGHT}px` }}>
      {/* Links container with continuous track background */}
      <div className="relative flex flex-col">
        {/* Track extends full height of content, not just visible area */}
        <div className="bg-background-400 absolute top-0 bottom-0 w-1" style={trackStyle} />

        {headings.map(({ id, text, level }) => (
          <JumpLinkItem
            key={id}
            id={id}
            text={text}
            isActive={activeId === id}
            indent={(level - minLevel) * scaledIndentMultiplier}
            scaledTextPadding={scaledTextPadding}
            scaledFontSize={scaledFontSize}
            trackStyle={trackStyle}
            onClick={() => onScrollTo(id)}
          />
        ))}
      </div>
    </nav>
  )
);

JumpLinksList.displayName = 'JumpLinksList';
